import AiModal from './AiModal';

export default AiModal;
